import { render, staticRenderFns } from "./VDots.vue?vue&type=template&id=3611f3ce&"
import script from "./VDots.vue?vue&type=script&lang=js&"
export * from "./VDots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports